import styled from 'styled-components';

export const Prompt = styled.div`
  position: fixed;
  z-index: 60;
  left: 12px;
  right: 12px;
  bottom: calc(env(safe-area-inset-bottom) + 12px);
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 10px 10px 16px;
  border-radius: 14px;
  background: #0b1a13;
  box-shadow: 0 0 0 1px var(--line), 0 10px 30px rgba(0, 0, 0, .6);
`;

export const PromptText = styled.div`
  flex: 1;
  font-weight: 600;
`;
